<template>
  <div class="rpt">

    <!-- ═══ Conversiones ═══ -->
    <div class="rpt__section">
      <div class="rpt__section-header">
        <i class="fa-solid fa-arrows-rotate rpt__section-icon rpt__section-icon--primary"></i>
        <span class="rpt__section-title">Conversiones</span>
      </div>
      <div class="rpt__conversiones">
        <div class="rpt__conv-item">
          <label class="rpt__filter-label">{{ 'Dolar: ' + dolarFecha }}</label>
          <b-form-input placeholder="Precio" v-model="dolar" class="rpt__conv-input" />
        </div>
        <div class="rpt__conv-item">
          <label class="rpt__filter-label">{{ 'Libra: ' + libraFecha }}</label>
          <b-form-input placeholder="Precio" v-model="libra" class="rpt__conv-input" />
        </div>
        <div class="rpt__conv-item">
          <label class="rpt__filter-label">Mes Exchange</label>
          <v-select
            v-model="mesExchangeSelect"
            label="nombre"
            :options="mesesOption"
          />
        </div>
      </div>
    </div>

    <!-- ═══ Subir report ═══ -->
    <div class="rpt__section">
      <div class="rpt__section-header">
        <i class="fa-solid fa-cloud-arrow-up rpt__section-icon rpt__section-icon--success"></i>
        <span class="rpt__section-title">Subir report Shopify</span>
      </div>
      <div class="rpt__upload">
        <div class="rpt__upload-file">
          <b-form-file
            v-model="csvInput"
            placeholder="Selecciona un archivo o arrastra aqui..."
            drop-placeholder="Suelta el archivo aqui..."
          />
        </div>
        <button class="rpt__btn rpt__btn--primary" @click="addVentaDiaria">
          <i class="fa-solid fa-gear"></i> Procesar
        </button>
      </div>
      <div class="rpt__ejemplo-toggle">
        <span class="rpt__ejemplo-btn" @click="viewSampleTemplate = !viewSampleTemplate">
          Ejemplo
          <i v-if="!viewSampleTemplate" class="fa-solid fa-chevron-down"></i>
          <i v-else class="fa-solid fa-chevron-up"></i>
        </span>
      </div>
      <div v-if="viewSampleTemplate" class="rpt__ejemplo-content">
        <div class="rpt__tabla-scroll">
          <b-table responsive="sm" :items="itemsSample" class="rpt__table" />
        </div>
        <div class="rpt__ejemplo-download">
          <span class="rpt__link" @click="downloadTemplate">
            <i class="fa-solid fa-download"></i> Descargar plantilla
          </span>
        </div>
      </div>
    </div>

    <!-- ═══ Resultados ═══ -->
    <div class="rpt__section">
      <div class="rpt__section-header">
        <i class="fa-solid fa-table rpt__section-icon rpt__section-icon--info"></i>
        <span class="rpt__section-title">Resultados</span>
        <button class="rpt__btn-icon" @click="copyTable()" v-b-tooltip.hover title="Copiar tabla">
          <i class="fa-solid fa-clone"></i>
        </button>
      </div>
      <p v-if="revisar != ''" class="rpt__alert">
        <i class="fa-solid fa-triangle-exclamation"></i> No encontrado: {{ revisar }}
      </p>
      <p v-if="revisarExchangue != ''" class="rpt__alert">
        <i class="fa-solid fa-triangle-exclamation"></i> Revisar calculos de: {{ revisarExchangue }}
      </p>
      <div class="rpt__table-card">
        <div class="rpt__tabla-scroll">
          <b-table
            :items="linesTable"
            :fields="columnasTable"
            class="rpt__table"
            no-border-collapse
            sort-icon-left
            :fixed="true"
            hover
          >
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@axios";
import vSelect from "vue-select";
// import BCardCode from "@core/components/b-card-code";
import { BRow, BCol, BFormFile, BButton, BFormInput, BTable } from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BFormFile,
    BFormInput,
    BTable,
    BButton,
    vSelect,
  },

  data() {
    return {
      //day,order_name,variant_sku,shipping_country,shipping_city,shipping_region,shipping_postal_code,customer_name,orders,total_sales
      viewSampleTemplate: false,
      itemsSample: [
        { day: '2023-03-01', order_name: '#49617', variant_sku: 'LEATHER-CUSTOMIZATION', shipping_country: 'United Kingdom', shipping_city: 'Bournemouth', shipping_region: 'England', shipping_postal_code: 'BH6 4JA', customer_name: 'Megan Clarke', orders: '1', total_sales: '6.75'},
        { day: '2023-03-01', order_name: '#49615', variant_sku: 'SLIM-SLEEVE-MACRETINA13-DB', shipping_country: 'France', shipping_city: 'Boulogne Billancourt', shipping_region: '', shipping_postal_code: '92100', customer_name: 'Nazrul Islam', orders: '1', total_sales: '79.00'},
      ],
      csvInput: [],
      fechaCambio: "",
      dolar: "",
      libra: "",
      revisar: "",
      revisarExchangue: "",
      columnasTable: [
        {
          key: "emc",
          label: "EMC",
          sortable: true,
        },
        {
          key: "descripcion",
          label: "Descripcion",
          sortable: true,
        },
        {
          key: "fecha",
          label: "Fecha",
          sortable: true,
        },
        {
          key: "baseImponible",
          label: "Base Imponible",
          sortable: true,
        },
        {
          key: "tipoImpositivo",
          label: "Tipo impositivo",
          sortable: true,
        },
        {
          key: "iva",
          label: "IVA",
          sortable: true,
        },
        {
          key: "importe",
          label: "Importe cobros",
          sortable: true,
        },
        {
          key: "nombre",
          label: "Nombre",
          sortable: true,
        },
        {
          key: "direccion",
          label: "Direccion",
          sortable: true,
        },
      ],
      linesTable: [],
      jsonPaises: [
        {
          code: "DE",
          english: "Germany",
          spanish: "Alemania",
          iva: "19",
        },
        {
          code: "AT",
          english: "Austria",
          spanish: "Austria",
          iva: "20",
        },
        {
          code: "BE",
          english: "Belgium",
          spanish: "Belgica",
          iva: "21",
        },
        {
          code: "BG",
          english: "Bulgary",
          spanish: "Bulgaria",
          iva: "20",
        },
        {
          code: "CY",
          english: "Cyprus",
          spanish: "Chipre",
          iva: "19",
        },
        {
          code: "HR",
          english: "Croatia",
          spanish: "Croacia",
          iva: "25",
        },
        {
          code: "DK",
          english: "Denmark",
          spanish: "Dinamarca",
          iva: "25",
        },
        {
          code: "SK",
          english: "Slovakia",
          spanish: "Eslovaquia",
          iva: "23",
        },
        {
          code: "SI",
          english: "Slovenia",
          spanish: "Eslovenia",
          iva: "22",
        },
        {
          code: "ES",
          english: "Spain",
          spanish: "España",
          iva: "21",
        },
        {
          code: "EE",
          english: "Estonia",
          spanish: "Estonia",
          iva: "22",
        },
        {
          code: "FI",
          english: "Finland",
          spanish: "Finlandia",
          iva: "25.50",
        },
        {
          code: "FR",
          english: "France",
          spanish: "Francia",
          iva: "20",
        },
        {
          code: "EL",
          english: "Greece",
          spanish: "Grecia",
          iva: "24",
        },
        {
          code: "HU",
          english: "Hungary",
          spanish: "Hungria",
          iva: "27",
        },
        {
          code: "IE",
          english: "Ireland",
          spanish: "Irlanda",
          iva: "23",
        },
        {
          code: "IT",
          english: "Italy",
          spanish: "Italia",
          iva: "22",
        },
        {
          code: "LV",
          english: "Latvia",
          spanish: "Letonia",
          iva: "21",
        },
        {
          code: "LT",
          english: "Lithuania",
          spanish: "Lituania",
          iva: "21",
        },
        {
          code: "LU",
          english: "Luxembourg",
          spanish: "Luxemburgo",
          iva: "17",
        },
        {
          code: "MT",
          english: "Malta",
          spanish: "Malta",
          iva: "18",
        },
        {
          code: "NL",
          english: "Netherlands",
          spanish: "Paises Bajos",
          iva: "21",
        },
        {
          code: "PL",
          english: "Poland",
          spanish: "Polonia",
          iva: "23",
        },
        {
          code: "PT",
          english: "Portugal",
          spanish: "Portugal",
          iva: "23",
        },
        {
          code: "CZ",
          english: "Czech Republic",
          spanish: "Republica Checa",
          iva: "21",
        },
        {
          code: "RO",
          english: "Romania",
          spanish: "Rumania",
          iva: "19",
        },
        {
          code: "SE",
          english: "Sweden",
          spanish: "Suecia",
          iva: "25",
        },
      ],
      mesExchangeSelect: "",
      mesesOption: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",],
      dolarFecha: "",
      libraFecha: "",
    };
  },
  methods: {
    loadItems() {
      axios.post("/uso", {seccion:"report"});
      /* this.dolar = 0.91963;
      this.libra = 1.138762; */
      axios
          .get("/shopify/exchange/USD")
          .then(response => {
              return response.data;
          })
          .then(res => {
            this.dolar = res.rates.EUR;
          });

        axios
          .get("/shopify/exchange/GBP")
          .then(response => {
              return response.data;
          })
          .then(res => {
            this.libra = res.rates.EUR;
          });

        axios
          .get("/shopify/exchange/min/GBP?year=2025&month=6")
          .then(response => {
              return response.data;
          })
          .then(res => {
            console.log(`GBP (${res.date}): ${res.rate} ` );
          });

        axios
          .get("/shopify/exchange/min/USD?year=2025&month=6")
          .then(response => {
              return response.data;
          })
          .then(res => {
            console.log(`USD (${res.date}): ${res.rate} ` );
          });

          //getMinExchangeRateGBP
    },
    addVentaDiaria() {
      var reader = new FileReader();
      reader.onload = (e) => {
        let data = reader.result.split(/\r?\n/);

        let fechaPeticion =
          data[1].split(",")[0].split("-")[1] +
          "/" +
          data[1].split(",")[0].split("-")[0];

          fechaPeticion = fechaPeticion.replaceAll('"',"");

        let dataExport = [];

        data.forEach((line) => {
          if (line != null && line != "") {
            dataExport.push(line.split(",")[1]);
          }
        });

        let uniqueChars = [...new Set(dataExport)];

        let listString = "";

        uniqueChars.forEach((element) => {          
          if (element != undefined && !element.includes('Order name')) {
            const numberOrder = element.replaceAll('"',"");
            if (listString == "") listString = "'" + numberOrder + "'";
            else listString += ",'" + numberOrder + "'";
          }
        });

        axios
          .post("/shopify/ordersId", { list: listString })
          .then((response) => {
            return response.data;
          })
          .then((res) => {
            
            const ordersShopify = res.filter((obj, index, self) =>
              index === self.findIndex(o => o.id === obj.id)
            );

            listString.split(",").forEach((data) => {
              let buscar = data.replaceAll("'", "");
              let index = ordersShopify.findIndex((x) => x.name === buscar);
              if (index == -1 && buscar != "order_name") {
                this.revisar += " " + data;
              }
            });


            //console.log(ordersShopify);


            ordersShopify.forEach((data) => {
              let descripcionParse = "";

              data.line_items.forEach((item) => {
                if (
                  item.sku != null &&
                  !item.sku.toLowerCase().includes("gift") &&
                  !item.sku.toLowerCase().includes("customization")
                ) {
                  descripcionParse = item.sku;
                }
              });

              let fechaParse = new Date(
                data.created_at.split("T")[0]
              ).toLocaleString([], {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              });

             /*  let fechaCreacionOrden = new Date(
                data.created_at.split("T")[0]
              ).toLocaleString([], {
                month: "2-digit",
                year: "numeric",
              }); */

              let fechaCreacionOrden = data.created_at.split("-")[1] + "/" + data.created_at.split("-")[0];

              let total = 0;

              if (fechaCreacionOrden == fechaPeticion) {
                total += this.convertEuro(data.total_price_set.shop_money.amount, data.total_price_set.shop_money.currency_code);
              }

              if (data.refunds != undefined) {
                data.refunds.forEach((element) => {
                  if (element.transactions != undefined) {
                    element.transactions.forEach((trans) => {

                      fechaCreacionOrden = trans.created_at.split("-")[1] + "/" + trans.created_at.split("-")[0];

                      if (fechaCreacionOrden == fechaPeticion) {

                        if(trans.currency != "EUR" && trans.currency != "GBP" && trans.currency != "USD" && trans.receipt.balance_transaction != undefined){
                          let totalTrans =  trans.amount *  trans.receipt.balance_transaction.exchange_rate;
                          total -= this.convertEuro(totalTrans, "GBP");
                        }else{
                          if(trans.currency != "EUR" && trans.currency != "GBP" && trans.currency != "USD" && trans.receipt.balance_transaction == undefined)
                            this.revisarExchangue += " " + data.name;

                          total -= this.convertEuro(trans.amount, trans.currency);
                        }
                      }
                    });
                  }
                });
              }

              let country = "";
              let direccionOrden = "";
              if (data.shipping_address == undefined) {
                country = data.billing_address.country;
                direccionOrden =
                  data.billing_address.name +
                  ", " +
                  data.billing_address.city +
                  ", " +
                  data.billing_address.zip +
                  ", " +
                  data.billing_address.country;
              } else {
                country = data.shipping_address.country;
                direccionOrden =
                  data.shipping_address.name +
                  ", " +
                  data.shipping_address.city +
                  ", " +
                  data.shipping_address.zip +
                  ", " +
                  data.shipping_address.country;
              }

              if (this.getTraduccionPais(country) != "" && total != 0) {
                total = Math.round(total * 100) / 100;
                let totalSinIva =
                  total / (this.getIva(country, false) / 100 + 1);
                totalSinIva = Math.round(totalSinIva * 100) / 100;
                let totalIva = total - totalSinIva;
                totalIva = Math.round(totalIva * 100) / 100;


                /*if(data.total_price_set.presentment_money.currency_code != "EUR" && data.total_price_set.presentment_money.currency_code != "GBP" && data.total_price_set.presentment_money.currency_code != "USD"){

                  console.log(data);
                }*/

                //74148

                let newLine = {
                  emc: this.getTraduccionPais(country),
                  descripcion: descripcionParse,
                  fecha: fechaParse,
                  baseImponible: totalSinIva,
                  tipoImpositivo: this.getIva(country),
                  iva: totalIva,
                  importe: total,
                  nombre: data.name,
                  direccion: direccionOrden,
                };

                this.linesTable.push(newLine);
              }
            });

          });
      };

      reader.readAsText(this.csvInput);
    },
    convertEuro(precio, moneda) {
      let res = 0;
      if (moneda == "GBP") res = precio * this.libra;
      else if (moneda == "USD") res = precio * this.dolar;
      else {
        //res = precio * exchangue;
        res = precio;
      }

      res = Math.round(res * 100) / 100;

      return res;
    },
    getIva(data, signo = true) {
      let res = "";
      this.jsonPaises.forEach((element) => {
        if (data == element.english || data == element.spanish) {
          if (signo) res = element.iva + "%";
          else res = element.iva;
        }
      });

      return res;
    },
    getTraduccionPais(data) {
      let res = "";
      this.jsonPaises.forEach((element) => {
        if (data == element.english || data == element.spanish) {
          res = element.spanish;
        }
      });

      return res;
    },
    copyTable() {
      var csv =
        "EMC;Descripcion;Cantidad;Fecha de compra;Base Imponible (£);Base Imponible (€);Tipo impositivo en el EMC;IVA en el EMC;Fecha;Importe cobros (€);Numero de Factura;Direccion de Envio\n";
      let fechaActual = new Date().toLocaleString([], {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

      this.linesTable.forEach((data) => {
        csv +=
          data.emc +
          ";" +
          data.descripcion +
          ";1;" +
          data.fecha +
          ";;" +
          data.baseImponible +
          ";" +
          data.tipoImpositivo +
          ";" +
          data.iva +
          ";" +
          fechaActual +
          ";" +
          data.importe +
          ";" +
          data.nombre +
          ";" +
          data.direccion +
          "\n";
      });

      navigator.clipboard.writeText(csv);

      this.$bvToast.toast(`Se ha copiado todos los resultado.`, {
                  title: 'Listado Copiado',
                  variant: 'success',
                  solid: true,
                })
    },
    downloadTemplate(){
      let csv = "day,order_name,variant_sku,shipping_country,shipping_city,shipping_region,shipping_postal_code,customer_name,orders,total_sales";

      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", 'data:text/csv;charset=utf-8,'+encodedUri);
      link.setAttribute("download","reportTemplate.csv");
      document.body.appendChild(link); 
      link.click();
    }
  },
  mounted() {
    this.loadItems();
  },
  watch: {
      async mesExchangeSelect(){
        const meses = {
            Enero: 1,
            Febrero: 2,
            Marzo: 3,
            Abril: 4,
            Mayo: 5,
            Junio: 6,
            Julio: 7,
            Agosto: 8,
            Septiembre: 9,
            Octubre: 10,
            Noviembre: 11,
            Diciembre: 12
          };

          const mesSeleccionadoTexto = this.mesExchangeSelect;
          const mesSeleccionado = meses[mesSeleccionadoTexto]; // convierte "Enero" → 1

          const fechaActual = new Date();
          const anioActual = fechaActual.getFullYear();
          const mesActual = fechaActual.getMonth() + 1;

          // Si aún no hemos llegado al mes seleccionado este año, usamos el año anterior
          const anio = mesSeleccionado > mesActual ? anioActual - 1 : anioActual;
        /*console.log(anio);
        console.log(mesSeleccionado);*/

        try {
          const resGBP = await axios.get(`/shopify/exchange/min/GBP?year=${anio}&month=${mesSeleccionado}`);
          //console.log(`GBP (${resGBP.data.date}): ${resGBP.data.rate}`);
          this.libraFecha = resGBP.data.date;
          this.libra = resGBP.data.rate;

          const resUSD = await axios.get(`/shopify/exchange/min/USD?year=${anio}&month=${mesSeleccionado}`);
          //console.log(`USD (${resUSD.data.date}): ${resUSD.data.rate}`);
          this.dolarFecha = resUSD.data.date;
          this.dolar = resUSD.data.rate;

        } catch (error) {
          console.error("Error obteniendo tipos de cambio:", error);
        }

      },
  }
};
</script>

<style lang="scss">
@import "../@core/scss/vue/libs/vue-select.scss";

/* ═══ Tabla global styles ═══ */
.rpt__table {
  margin-bottom: 0;

  thead th {
    background: #f8f9fb !important;
    border-bottom: 2px solid #e9ecf1 !important;
    border-top: none !important;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #8a8e99;
    padding: 12px 14px;
    white-space: nowrap;
  }

  tbody td {
    padding: 10px 14px;
    vertical-align: middle;
    border-bottom: 1px solid #f0f1f4 !important;
    border-top: none !important;
    font-size: 13px;
    color: #5e5873;
  }

  tbody tr {
    transition: background 0.15s;
    background: transparent !important;

    &:hover {
      background: #f9f8ff !important;
    }
  }
}

.dark-layout {
  .rpt__section {
    background: #242424 !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;
  }

  .rpt__section-title { color: #d0d2d6 !important; }
  .rpt__filter-label { color: #b4b7bd !important; }

  .rpt__btn-icon {
    background: #242424 !important;
    border-color: #333 !important;
    color: #b4b7bd !important;
  }

  .rpt__ejemplo-btn {
    background: #2e2e2e !important;
    color: #b4b7bd !important;
  }

  .rpt__table-card { border-color: #333 !important; }

  .rpt__table {
    thead th { background: #2e2e2e !important; border-bottom-color: #333 !important; color: #b4b7bd !important; }
    tbody td { color: #d0d2d6 !important; border-bottom-color: #333 !important; }
    tbody tr:hover { background: #2e2e2e !important; }
  }

  .rpt__alert {
    background: #3a1e1e !important;
  }
}
</style>

<style scoped>
/* ═══ Layout ═══ */
.rpt {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ═══ Secciones ═══ */
.rpt__section {
  background: #fff;
  border-radius: 14px;
  padding: 20px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.rpt__section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.rpt__section-icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.rpt__section-icon--primary { background: #eeedfd; color: #7367f0; }
.rpt__section-icon--success { background: #e8fce8; color: #28c76f; }
.rpt__section-icon--info    { background: #e0f4ff; color: #00cfe8; }

.rpt__section-title {
  font-size: 15px;
  font-weight: 600;
  color: #3b4253;
}

/* ═══ Conversiones ═══ */
.rpt__conversiones {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
}

.rpt__conv-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 150px;
}

.rpt__filter-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8a8e99;
  margin-bottom: 0;
}

/* ═══ Upload ═══ */
.rpt__upload {
  display: flex;
  align-items: center;
  gap: 14px;
}

.rpt__upload-file {
  flex: 1;
}

/* ═══ Botones ═══ */
.rpt__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 20px;
  border-radius: 10px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.rpt__btn--primary {
  background: linear-gradient(135deg, #7367f0 0%, #9b8cf8 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.35);
}
.rpt__btn--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(115, 103, 240, 0.45);
}

.rpt__btn-icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  border: 1px solid #dfe3e8;
  background: #fff;
  color: #6e6b7b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s;
  margin-left: auto;
}
.rpt__btn-icon:hover {
  background: #7367f0;
  color: #fff;
  border-color: #7367f0;
}

/* ═══ Ejemplo ═══ */
.rpt__ejemplo-toggle {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}

.rpt__ejemplo-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #6e6b7b;
  background: #f8f9fb;
  cursor: pointer;
  transition: all 0.2s;
}
.rpt__ejemplo-btn:hover {
  background: #eeedfd;
  color: #7367f0;
}

.rpt__ejemplo-content {
  margin-top: 12px;
}

.rpt__ejemplo-download {
  text-align: center;
  margin-top: 8px;
}

.rpt__link {
  font-size: 13px;
  font-weight: 600;
  color: #7367f0;
  cursor: pointer;
  transition: color 0.2s;
}
.rpt__link:hover {
  color: #5a4fd4;
}

/* ═══ Alertas ═══ */
.rpt__alert {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 10px;
  background: #fce4e4;
  color: #ea5455;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 12px;
}

/* ═══ Tabla card ═══ */
.rpt__table-card {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #f0f1f4;
}

.rpt__tabla-scroll {
  width: 100%;
  overflow-x: auto;
}
</style>